import Benutzerliste from "@/pages/Dashboardlisten/Benutzerliste";
import Benutzer from "@/pages/Admin/Benutzer";

export default [
  {
    path: "/admin/benutzerliste",
    name: "benutzer-liste",
    component: Benutzerliste,
  },
  {
    path: "/admin/benutzer/:id?/:anzeige",
    name: "benutzer",
    component: Benutzer,
    props: (route) => {
      const a = parseInt(route.params.anzeige, 10);
      return {
        id: route.params.id,
        anzeige: isNaN(a) ? 0 : a,
      };
    },
  },
];